import { Immutable } from 'immer';
import { NetworkEntitiesCollecion } from 'store';

import { PoolCounters } from '@/models/Company/Counters';
import { Pool } from '@/models/Company/Pool';

interface PoolsStateInterface {
  counters?: PoolCounters;
  pools: NetworkEntitiesCollecion<Immutable<Pool>>;
}

export type PoolsState = Immutable<PoolsStateInterface>;

export const initialPoolsState: PoolsState = {
  pools: {},
};
